import { useRef as t, useReducer as r, useMemo as n, useEffect as u } from "react";
import { makeSubject as c, subscribe as e } from "wonka";

var i = function i(_i, o, a) {
  var p = t({
    active: !1,
    output: a
  }),
      f = r(function (t, r) {
    return p.current.output = r, t + 1;
  }, 0)[1];

  function v(t) {
    p.current.active ? p.current.output = t : f(t);
  }

  var m = n(function () {
    var t = c(),
        r = t[0],
        n = t[1];
    return [function (t) {
      p.current.active ? "input" in p.current && t === p.current.input || (p.current.input = t, n(t)) : n(t);
    }, e(v)(_i(r))[0]];
  }, []),
      k = m[0],
      w = m[1];
  return p.current.active = !0, k(o), p.current.active = !1, u(function () {
    return w;
  }, []), [p.current.output, k];
},
    o = function o(t, r, n) {
  return i(t, r, n)[0];
};

export { o as useStreamValue, i as useSubjectValue };